var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisabledByDefault(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 960 960",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 960) scale(1 -1)",
    d: "M480 421L595 307Q607 295 624.5 295Q642 295 653.5 307Q665 319 665 336.5Q665 354 653 365L539 480L653 595Q665 607 665 624.5Q665 642 653.5 653.5Q642 665 624.5 665Q607 665 595 653L480 539L365 653Q353 665 336 665Q319 665 307 653.5Q295 642 295 624.5Q295 607 307 595L421 480L307 365Q295 353 295 336Q295 319 307 307Q319 295 336.5 295Q354 295 365 307ZM203 112Q165 112 138.5 138.5Q112 165 112 203L112 757Q112 795 138.5 821.5Q165 848 203 848L757 848Q795 848 821.5 821.5Q848 795 848 757L848 203Q848 165 821.5 138.5Q795 112 757 112Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledByDefault);
export default __webpack_public_path__ + "static/media/disabled_by_default.6cb7d04320823ec209e37c221bfa7555.svg";
export { ForwardRef as ReactComponent };